export const scrollToTop = () => {
    const button = document.querySelector('.scroll-to-top');
    if (button) {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
};
